// ============================================================
// Mock data — Radar / Bandeja de oportunidades (Infonalia)
//
// Representa el Excel diario que el equipo recibe por correo.
// Cada fila es una oportunidad "ligera" que aún NO es licitación:
// se revisa, se puntúa (bid/no-bid) y se preselecciona o descarta.
//
// Mapeo de columnas Infonalia → campos:
//   Objeto→title · OrganismoConvocante→entity · Presupuesto→budget
//   PlazoPresentacionFecha→deadline · InformacionWeb→url
//   LugarEjecucion→region · Nº Expediente→code · TipoDato→type
// ============================================================
export const MOCK_OPPORTUNITIES = [
  {
    id: 'opp-2026086521',
    type: 'Concurso',
    source: 'Plataforma de Contratación del Estado',
    code: 'E153/2026',
    title: 'Servicio de impartición de acciones formativas en competencias digitales',
    entity: 'Consejo de Administración — Agencia para la Modernización',
    entityShort: 'Agencia Modernización',
    region: 'Madrid',
    cpv: '80500000-9 · Servicios de formación',
    budget: 53_391.96,
    introducedAt: '2026-06-18',
    deadline: '2026-07-02',
    url: 'https://contrataciondelestado.es/E153-2026',
    status: 'new',
  },
  {
    id: 'opp-2026086535',
    type: 'Concurso',
    source: 'Plataforma de Contratación del Estado',
    code: 'A2026/008161',
    title: 'Servicios de auditoría y control financiero de proyectos cofinanciados',
    entity: 'Consejería de Cultura, Turismo y Deporte',
    entityShort: 'Consejería Cultura',
    region: 'Castilla y León',
    cpv: '79212000-3 · Servicios de auditoría',
    budget: 4_108.0,
    introducedAt: '2026-06-18',
    deadline: '2026-07-01',
    url: 'https://contrataciondelestado.es/A2026-008161',
    status: 'new',
  },
  {
    id: 'opp-2026086540',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'EXP/2026/0931',
    title: 'Servicio de dinamización del vivero de empresas y apoyo al emprendimiento',
    entity: 'Ayuntamiento de Hortaleza — Desarrollo Económico',
    entityShort: 'Ayto. Hortaleza',
    region: 'Madrid',
    cpv: '79410000-1 · Servicios de consultoría',
    budget: 692_280.0,
    introducedAt: '2026-06-18',
    deadline: '2026-07-09',
    url: 'https://infonalia.es/opp/2026086540',
    status: 'new',
  },
  {
    id: 'opp-2026086551',
    type: 'Anuncio previo',
    source: 'Infonalia',
    code: 'PRE/2026/0042',
    title: 'Asistencia técnica para el seguimiento del Plan de Acción Local 2024-2027',
    entity: 'Ayuntamiento de Vitoria-Gasteiz',
    entityShort: 'Ayto. Vitoria',
    region: 'País Vasco',
    cpv: '90712000-1 · Planificación medioambiental',
    budget: 247_930.0,
    introducedAt: '2026-06-17',
    deadline: '2026-07-20',
    url: 'https://infonalia.es/opp/2026086551',
    status: 'new',
  },
  {
    id: 'opp-2026086560',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'BDTN/2026/118',
    title: 'Servicios de coaching ejecutivo para startups vinculadas a Barcelona Deep Tech Node',
    entity: 'Barcelona Activa SAU SPM',
    entityShort: 'Barcelona Activa',
    region: 'Cataluña',
    cpv: '79634000-7 · Servicios de orientación profesional',
    budget: 35_572.5,
    introducedAt: '2026-06-17',
    deadline: '2026-07-01',
    url: 'https://infonalia.es/opp/2026086560',
    status: 'preselected',
  },
  {
    id: 'opp-2026086571',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'MIEB/2026/77',
    title: 'Encuentro Anual de alumni del Programa de Preincubación (MIEB)',
    entity: 'Móstoles Desarrollo, Promoción Económica S.A.',
    entityShort: 'Móstoles Desarrollo',
    region: 'Madrid',
    cpv: '79952000-2 · Servicios de organización de eventos',
    budget: 65_783.48,
    introducedAt: '2026-06-16',
    deadline: '2026-07-09',
    url: 'https://infonalia.es/opp/2026086571',
    status: 'new',
  },
  {
    id: 'opp-2026086582',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'UPC/2026/441',
    title: 'Programa de liderazgo y dirección para la economía social y de impacto',
    entity: 'Universitat Politècnica de Catalunya (UPC)',
    entityShort: 'UPC',
    region: 'Cataluña',
    cpv: '80510000-2 · Servicios de formación especializada',
    budget: 300_000.0,
    introducedAt: '2026-06-16',
    deadline: '2026-07-15',
    url: 'https://infonalia.es/opp/2026086582',
    status: 'new',
  },
  {
    id: 'opp-2026086590',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'ALM/2026/210',
    title: 'Oficina técnica de impulso empresarial del municipio',
    entity: 'Alcaldía del Ayuntamiento de Almassora',
    entityShort: 'Ayto. Almassora',
    region: 'C. Valenciana',
    cpv: '79410000-1 · Servicios de consultoría',
    budget: 231_000.0,
    introducedAt: '2026-06-15',
    deadline: '2026-06-30',
    url: 'https://infonalia.es/opp/2026086590',
    status: 'new',
  },
  {
    id: 'opp-2026086601',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'CAM/2026/882',
    title: 'Programa de incubación de drones y movilidad aérea avanzada',
    entity: 'Comunidad de Madrid — Innovación',
    entityShort: 'C. de Madrid',
    region: 'Madrid',
    cpv: '73220000-0 · Servicios de consultoría en desarrollo',
    budget: 540_000.0,
    introducedAt: '2026-06-15',
    deadline: '2026-07-22',
    url: 'https://infonalia.es/opp/2026086601',
    status: 'new',
  },
  {
    id: 'opp-2026086612',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'POCTEP/2026/19',
    title: 'Red de mentores del ecosistema transfronterizo (Interreg VI-A España-Portugal)',
    entity: 'Diputación de Badajoz',
    entityShort: 'Dip. Badajoz',
    region: 'Extremadura',
    cpv: '79411000-8 · Servicios de consultoría en gestión',
    budget: 410_000.0,
    introducedAt: '2026-06-14',
    deadline: '2026-07-18',
    url: 'https://infonalia.es/opp/2026086612',
    status: 'discarded',
  },
  {
    id: 'opp-2026086620',
    type: 'Concurso',
    source: 'Plataforma de Contratación del Estado',
    code: 'GAL/2026/305',
    title: 'Plan de actuación y planes de sostenibilidad para pymes industriales',
    entity: 'Axencia Galega de Innovación',
    entityShort: 'GAIN',
    region: 'Galicia',
    cpv: '90713000-8 · Servicios de consultoría medioambiental',
    budget: 300_080.0,
    introducedAt: '2026-06-14',
    deadline: '2026-07-11',
    url: 'https://contrataciondelestado.es/GAL-2026-305',
    status: 'new',
  },
  {
    id: 'opp-2026086633',
    type: 'Concurso',
    source: 'Infonalia',
    code: 'NAV/2026/056',
    title: 'Asistencia técnica para la aceleración de proyectos de economía circular',
    entity: 'Sodena — Sociedad de Desarrollo de Navarra',
    entityShort: 'Sodena',
    region: 'Navarra',
    cpv: '79410000-1 · Servicios de consultoría',
    budget: 124_500.0,
    introducedAt: '2026-06-13',
    deadline: '2026-07-04',
    url: 'https://infonalia.es/opp/2026086633',
    status: 'new',
  },
];
